import { Outlet } from 'react-router-dom'
import NavBar from '../components/common/navbar';
import Footer from '../components/common/footer';

export default function Open() {

  return (
    <>
      <NavBar />
      <div className='App p-2 text-center w-full flex align-items-center justify-content-center'>
        <div className='w-11' >
        <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}
